"use client";
import React, { FC, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import axios from "axios";
import Link from "next/link";
import { GetOnboardinData, actions } from "@/store/questionniareSlice";
import { getCustIdFromLS, getStpRoomTypeFromLS } from "@/utils/useUserInfo";
import ClientComponent from "@/components/builder/client_component";
import { Box, Button, Grid, Paper } from "@mui/material";
import Typography from "@mui/material/Typography";
import scanTip_1 from "../../../assets/images/scan_tip_1.png";
import scanTip_2 from "../../../assets/images/scan_tip_2.png";
import scanTip_3 from "../../../assets/images/scan_tip_3.png";
import qr_code from "../../../assets/images/app_navigation_qr_code_live.png";
import AppleIcon from "@mui/icons-material/Apple";
import cssStyles from "./questioniar_component.module.scss";
import Layer from "@/components/layer";
import { navigateAndReplaceHistory, navigateWithHistory } from "@/utils";
import uploadInstructionImg from "./../../../assets/images/uploadinstruction.jpg";
import Divider from '@mui/material/Divider';

export interface Root {
  roomId: number;
  roomName: string;
  roomDisplayName: string;
  styleId: number;
  style: string;
  styleDisplayName: string;
  vendorId: number;
  vendorName: string;
  designs: Design[];
}

export interface Design {
  designId: string
  designName: string
  designImage: string
  model3dAsset: Model3dAsset
  thumbnailAsset: ThumbnailAsset
  design3dImage: string
  products: any[]
}

export interface Model3dAsset {
  bundleName: string
  bundleUrl: string
  jsonUrl: string
}

export interface ThumbnailAsset {
  bundleName: string
  bundleUrl: string
  jsonUrl: string
}



const Instructions: FC<any> = ({ designData }) => {
  return (
    <div className={cssStyles.instruction_tip}>
      <Typography variant="h3" sx={{ backgroundColor: 'buttons_text.info' }}>
        You&apos;re in complete control of your dream home. It&apos;s easy to get started!
      </Typography>
      {designData && (designData?.designs as Design[]).length > 0 &&
        <>
          <Grid container spacing={2} className={cssStyles.upload_header}>
            <Grid item xs={12} md={6}>
              {
                designData?.designs[0]?.designImage && <img src={designData?.designs[0]?.designImage} alt="upload instruction" />
              }
            </Grid>
            <Grid item xs={12} md={6}>
              <p>Please scan the QR code to download the app and view the {
                designData?.designs[0]?.designName && <strong>{designData?.designs[0]?.designName}</strong>
              }  design in your room</p>
            </Grid>
          </Grid>
          <Divider sx={{ borderColor: 'buttons_text.info', borderWidth: '3px', opacity: '1', marginBottom: '10px' }} />
        </>
      }

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <div className={cssStyles.step_container_scan}>
            <p>
              <span>1</span>Download the App
            </p>
            <div className={cssStyles.step_container_desp}>
              <img src={qr_code.src} />
              <p>iPhone Pro (12 and above) users Scan the QR code with your phone camera to download the Nestingale app.
                If you have a different phone model, click below.</p>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={4}>
          <div className={cssStyles.step_container_scan}>
            <p>
              <span>2</span>Scan your room
            </p>
            <div className={cssStyles.step_container_desp}>
              <img src={scanTip_2.src} />
              <p>Scan your room with our easy peasy app and discover designs and products which are a perfect match for your space.</p>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={4}>
          <div className={cssStyles.step_container_scan}>
            <p>
              <span>3</span>Unlock personalized designs
            </p>
            <div className={cssStyles.step_container_desp}>
              <img src={scanTip_3.src} />
              <p>Visualize your room immersively with our magic renderer to reach the clarity of vision for your space.</p>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};


const NoRoomsComponent: FC = ({ heading }: any) => {
  return (<div>
    <p>{heading}</p>
  </div>)
}

export const filterRooms3DdataByGlbUrl = (roomsData: Array<any> = []) => {
  return roomsData.filter((eachRoom: any) => {

    if (eachRoom.origin == "web" && eachRoom.room2dFloorWithDimensions) {
      return true;
    }

    return eachRoom.glbUrl != undefined || eachRoom.glbUrl != null || eachRoom.thumbnail
  })
}

// define enum constants for roomdata loading status
enum RoomsLoadingStatus {
  INIT = "init",
  LOADING = "loading",
  LOADED = "loaded",
  PROCESSING = "processing",
  NOT_LOADED = "not_loaded",
  NO_ROOMS_FOUND = "no_rooms_found",
  MORE_ROOMS_FOUND = "more_rooms_found"
}


const UploadYourHomeInstructions: React.FC<any> = (props) => {
  const navigate = useRouter();
  const [showOverlay, setShowOverlay] = useState<any>(false);
  const [designData, setDesignData] = useState<Root | null>(null);
  const { rooms3Ddata, getRooms3DInfo } = GetOnboardinData();
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [roomsLoadingStatus, setRoomsLoadingStatus] = useState<RoomsLoadingStatus >(RoomsLoadingStatus.INIT);
  const [roomsLoadingStatusText, setRoomsLoadingStatusText] = useState<string>("");


  let roomType = useRef((navigate.query.roomType ? navigate.query.roomType as string : undefined ));
  let roomId = useRef(navigate.query.roomId ? navigate.query.roomId as string : undefined);
  let style = useRef(navigate.query.style ? navigate.query.style as string : undefined);
  let designId = useRef(navigate.query.designId ? navigate.query.designId as string : undefined);
  //let roomLabel = useRef(navigate.query.roomLabel ? navigate.query.roomLabel as string : undefined);
  

  useEffect(() => {
    console.log("UploadYourHomeInstructions: useEffect: props.userInfo = ", props.userInfo, " loadRoomsData = ", roomsLoadingStatus);
    const userInfo = props.userInfo;
    if (userInfo) {
      setIsLoggedIn(!(userInfo.unauthorized === true))
      if (userInfo.unauthorized) {
//         return navigateAndReplaceHistory(navigate, `/login?next=${encodeURIComponent(window.location.href)}`);
      } else if (userInfo.cId) {
        if (designId.current && !designData) {
          (async () => {
            try {
              const GET_DESIGN_URL = `https://d221a61rb87vel.cloudfront.net/v2/api/designs?designId=${designId.current}`;
              const response = await axios.get(GET_DESIGN_URL);
              if (response.data && !response.data.errorDescription) {
                setDesignData(response.data as any);
              }
            } catch (e) {
              console.error(e);
            }
          })()
        }
      }

    }
  }, [props.userInfo, roomsLoadingStatus]);

  useEffect(() => {
    if (rooms3Ddata && rooms3Ddata.errorDescription) {
      setRoomsLoadingStatusText(rooms3Ddata.errorDescription);
    }
    if (roomsLoadingStatus === RoomsLoadingStatus.LOADING) {
      setRoomsLoadingStatusText("Looking for your recently scanned rooms...");
    }
    if (roomsLoadingStatus === RoomsLoadingStatus.NO_ROOMS_FOUND) {
      setRoomsLoadingStatusText("We haven't found any rooms you scanned recently. Please check back after scanning...");
    }
    if (roomsLoadingStatus === RoomsLoadingStatus.PROCESSING) {
      setRoomsLoadingStatusText("Processing your most recently scanned room! Please wait...");
    }
    if (roomsLoadingStatus === RoomsLoadingStatus.LOADED) {

      setRoomsLoadingStatusText("Redirecting you to an immersive experience...");
    }
  }, [roomsLoadingStatus]);

  useEffect(() => {
    if (roomsLoadingStatus === RoomsLoadingStatus.LOADING){
      getRooms3DInfo({
        roomType: roomType.current || "",
        customerID: props.userInfo.cId,
        roomId: roomId.current
      });
    }
  }, [roomsLoadingStatus]); 

  useEffect(() => {

    console.log("UploadYourHomeInstructions: navigateToViewVirtualRoom: rooms3Ddata = ", rooms3Ddata, " loadRoomsData = ", roomsLoadingStatus);
    if (roomsLoadingStatus !== RoomsLoadingStatus.LOADING || !rooms3Ddata?.rooms) {
      return;
    }

    let rooms = rooms3Ddata?.rooms;
    let roomData;
    if(rooms?.length == 0){
      setRoomsLoadingStatus(RoomsLoadingStatus.NO_ROOMS_FOUND);
    } else if (rooms?.length > 0) {
      // find first room which has glbUrl
      roomData = rooms.find((room: any) => (room.glbUrl || room.usdzUrl));
      
      if (!roomData) {
        //navigateAndReplaceHistory(navigate, getMyRoomsUrl());
        setRoomsLoadingStatus(RoomsLoadingStatus.NO_ROOMS_FOUND);
        return;
      }

      if ( roomData.roomId != roomId.current) {
        roomId.current = roomData.roomId;
        roomType.current = roomData.roomType;
      }

      if ( roomData.glbUrl) {
        setRoomsLoadingStatus(RoomsLoadingStatus.LOADED);
        const destinationUrl = getDestinationUrl(roomData, false);
        console.log("---------upload instructions------", 'roomData:', roomData, 'destinationUrl: ',  destinationUrl)
        navigateAndReplaceHistory(navigate, destinationUrl);
        return;
      } else if (roomData.usdzUrl) {
        setRoomsLoadingStatus(RoomsLoadingStatus.PROCESSING);
      } 

      setRoomsLoadingStatus(RoomsLoadingStatus.LOADED);

      return;
    }

  }, [rooms3Ddata]);

  const navigateToViewVirtualRoom = () => {

    if (!isLoggedIn) {
      return navigateAndReplaceHistory(navigate, `/login?next=${encodeURIComponent(window.location.href)}`);
    }

    setRoomsLoadingStatus(RoomsLoadingStatus.LOADING);
    //setRoomsLoadingStatus(RoomsLoadingStatus.LOADING);
  }

  function getMyRoomsUrl(): string {
    let myroomsUrl = '';
    let brandPathEntry = props.brandPathEntry
    if (brandPathEntry) {
      myroomsUrl += `/${brandPathEntry}`;
    }
    if (roomType.current) {
      myroomsUrl += `/myrooms?roomType=${roomType.current}`;
    }

    if (roomId.current) {
      myroomsUrl += `&roomId=${roomId.current}`;
    } 

    if (designData?.style) {
      myroomsUrl += `&style=${designData?.style}`
    }
    if (designId.current) {
      myroomsUrl += `&designId=${designId.current}`;
    }
    if (!isLoggedIn) {
      myroomsUrl = '/login?next=' + encodeURIComponent(myroomsUrl);
    }
    return myroomsUrl;
  }

  const getDestinationUrl = (roomData:any, is2DFlow?: boolean) => {
    let destinationUrl = '';
    let brandPathEntry = props.brandPathEntry
    if (brandPathEntry) {
      destinationUrl += `/${brandPathEntry}`;
    }
    let destinationUrlParms = [];
    if(is2DFlow){
      destinationUrl += `/builder`;
      destinationUrlParms.push(`createRoom=true`);
    } else {
      roomData.isRoomQuizComplete ? destinationUrl += `/builder` : destinationUrl += `/myrooms`
      destinationUrlParms.push(`ssrq=true`);
    }
    roomType.current && destinationUrlParms.push(`roomType=${roomType.current}`);
    roomId.current && destinationUrlParms.push(`roomId=${roomId.current}`);
    designId.current &&  destinationUrlParms.push(`designId=${designId.current}`);
    style.current && destinationUrlParms.push(`style=${style.current}`)

    if (destinationUrlParms.length > 0) {
      destinationUrl += '?' + destinationUrlParms.join('&');
    }
    if (!isLoggedIn) {
      destinationUrl = '/login?next=' + encodeURIComponent(destinationUrl);
    }
    return destinationUrl;
  }

  if (props.overlay) {
    return (
      <Grid container justifyContent="center">
        <Grid item xs={12} md={12} lg={10}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {typeof window !== "undefined" && window.innerWidth < 640 ? (
                <div className={cssStyles.download_app_box}>
                  <Link
                    href={"https://testflight.apple.com/join/BMhHsC0W"}
                    className={cssStyles.app_download}
                  >
                    <AppleIcon />
                    Download Nestingale App
                  </Link>
                </div>
              ) : (
                <></>
              )}
              <div className={cssStyles.upload_instructions}>
                <Paper
                  elevation={0}
                  square
                  className={cssStyles.instruction_container}
                >
                  {typeof window !== "undefined" && window.innerWidth > 639 && (
                    <>
                      <Instructions designData={designData} />
                    </>
                  )}


                </Paper>
                <Paper
                  elevation={0}
                  square
                  className={cssStyles.instruction_footer}
                >
                  <div style={{ display: "flex", alignItems: 'center', height: '100px', width: '80%', margin: '0 auto' }}>
                    <Button
                      id="upload_instructions_page.create_my_room_plan"
                      color="secondary"
                      href={getDestinationUrl(null as any, true)}
                      sx={{
                        textTransform: 'none',
                        minHeight: '38px',
                        textAlign: 'center'
                      }}
                    >
                      Create my room plan in a few clicks
                    </Button>
                    <Divider orientation="vertical" sx={{marginLeft:'auto'}} variant="middle" flexItem />
                    <Box component="div" sx={{ marginLeft: 'auto', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>
                      <p style={{ 'margin': '0' }}><strong style={{ 'fontSize': 'small' }}>Please click after scanning your room</strong></p>
                      <Button
                        id="upload_instructions_page.appQRcode_viewed"
                        color="primary"
                        onClick={navigateToViewVirtualRoom}
                        sx={{
                          textTransform: 'none'
                        }}
                      >
                        {isLoggedIn ? 'View my virtual room plan' : 'Login to see virtual floor plan'}
                      </Button>

                      <p style={{ 'margin': '5px', 'maxWidth': '300px' }}>
                          <strong style={{ 'fontSize': 'small', color:"#095F6A" }}> {roomsLoadingStatusText} </strong>
                        </p>
                    </Box>

                  </div>
                </Paper>
              </div>

              {
                (showOverlay) ?
                  <Layer
                    open={showOverlay}
                    onClose={() => setShowOverlay(false)}
                    Element={NoRoomsComponent}
                    dialogContentClassName={''}
                    dialogContentComponentProps={{
                      heading: 'Please Rescan to proceed further'
                    }}
                    dialogTitle={`NO ROOMS FOUND`} /> : <></>
              }
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return <Instructions />;
};

export default ClientComponent(UploadYourHomeInstructions);
